import { LoadingOutlined } from "@ant-design/icons";

import ArticleCard from "../../article/ArticleCard";
import "./ArticlesList.scss";

const ArticlesList = ({ products, productsLoaded }: any) => {
  if (productsLoaded === false) {
    return <LoadingOutlined />;
  }
  return (
    <div className="Aricles-Container">
      {products.length !== 0 &&
        products.map((article: any, id: number) => {
          return (
            <div className="Aricle-Item" key={article.article_slug}>
              <ArticleCard article={article} />
            </div>
          );
        })}
    </div>
  );
};
export default ArticlesList;
